import { Injectable } from '@angular/core';
import { HeaderTitle } from '../models/header-title';


@Injectable()
export class HeaderTitleService {

  private _isShowTitle: boolean;
  private _currentTitle: HeaderTitle;

  constructor() { }

  get isVisibleTitle(): boolean {
    return this._isShowTitle;
  }

  set isVisibleTitle(value: boolean) {
    this._isShowTitle = value;
  }

  set title(value: string) {
    if (!value) {
      return;
    }
    this._currentTitle = new HeaderTitle(value);
  }

  get titleName(): string {
    return this._currentTitle?.name || '';
  }

  resetTitle(): void {
    this._currentTitle = null;
    this._isShowTitle = false;
  }

}
